import { applyMiddleware, combineReducers, createStore } from "redux";

// Reducers
import { INITIAL_STATE_KEY } from "core-web/constants";
import applicationReducer from "core-web/state/models/Application/reducers";
import basketReducer from "core-web/state/models/Basket/reducers";
import { composeWithDevTools } from "redux-devtools-extension";
import footerReducer from "core-web/state/models/Footer/reducers";
import headerReducer from "core-web/state/models/Header/reducers";
import modalReducer from "core-web/state/models/Modal/reducers";
import overlayReducer from "core-web/state/models/Overlay/reducers";
import pageReducer from "core-web/state/models/Page/reducers";
import popupsReducer from "core-web/state/models/Popups/reducers";
import productsReducer from "core-web/state/models/Products/reducers";
import searchReducer from "core-web/state/models/Search/reducers";
import storesReducer from "core-web/state/models/Stores/reducers";
import thunk from "redux-thunk";
import userReducer from "core-web/state/models/User/reducers";

export const initiateStore = (initialState = {}, middleWares = []) =>
    createStore(
        combineReducers({
            application: applicationReducer,
            basket: basketReducer,
            header: headerReducer,
            footer: footerReducer,
            overlay: overlayReducer,
            page: pageReducer,
            popups: popupsReducer,
            products: productsReducer,
            search: searchReducer,
            stores: storesReducer,
            user: userReducer,
            modal: modalReducer,
        }),
        initialState,
        composeWithDevTools(applyMiddleware(thunk, ...middleWares)),
    );

let store;
if (typeof window !== "undefined") {
    // added so we don't error out when compiling for SSR
    store = initiateStore(window[INITIAL_STATE_KEY] && JSON.parse(window[INITIAL_STATE_KEY]));
    delete window[INITIAL_STATE_KEY];
} else {
    // When we are creating a store for the SSR..
    store = initiateStore();
}
export default store;
